/* tslint:disable:no-console */
import { sha256 } from 'js-sha256';

export class EndeavourUtils {
  public static anonymizeString(toAnonymize: string): string {
    return sha256(toAnonymize);
  }
}
